import Script from "next/script";

export default function GoogleAnalyticsScript(props)
{
    if (process.env.NODE_ENV != "production") {
        return null;
    }

    return (
        <>
            <Script
                src="https://www.googletagmanager.com/gtag/js?id=G-B1QYWWM9Z2"
                strategy="afterInteractive"
                async
            />
            <Script
                id="google-analytics"
                strategy="afterInteractive"
            >
                {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', 'G-B1QYWWM9Z2');
                `}
            </Script>
        </>
    );
}